import { createStyles, Theme } from '@material-ui/core'

const GlobalBannerStyles = (theme: Theme) => createStyles({

})

export default GlobalBannerStyles
